import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeWithPartnerListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeWithPartnerListController.php
* @route '/api/funeral-home/funeral-home-with-partners'
*/
const GetFuneralHomeWithPartnerListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFuneralHomeWithPartnerListController.url(options),
    method: 'get',
})

GetFuneralHomeWithPartnerListController.definition = {
    methods: ["get","head"],
    url: '/api/funeral-home/funeral-home-with-partners',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeWithPartnerListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeWithPartnerListController.php
* @route '/api/funeral-home/funeral-home-with-partners'
*/
GetFuneralHomeWithPartnerListController.url = (options?: RouteQueryOptions) => {
    return GetFuneralHomeWithPartnerListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeWithPartnerListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeWithPartnerListController.php
* @route '/api/funeral-home/funeral-home-with-partners'
*/
GetFuneralHomeWithPartnerListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFuneralHomeWithPartnerListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeWithPartnerListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeWithPartnerListController.php
* @route '/api/funeral-home/funeral-home-with-partners'
*/
GetFuneralHomeWithPartnerListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetFuneralHomeWithPartnerListController.url(options),
    method: 'head',
})

export default GetFuneralHomeWithPartnerListController